var frslider = $('.prd_desc_thumb ul li:eq(0)').html();
$('.prd_big_slider').html(frslider);

$('.prd_desc_thumb ul li').click(function(e) {
    var changeImg = $(this).find('img').attr('src');
	
	$('.prd_big_slider').find('img').attr('src',changeImg);
});  

$(window).load(function(){
  $('.product_page_rht .text_rht .panel_wrap .heading').click(function(e) {
	
	$(this).parents('.panel_wrap').find('.accord_panel').slideDown();
	// $('.product_page_rht .text_rht #shopify-product-reviews').find('.spr-content').slideUp();
	
});
  
  
$('.product_page_rht .text_rht #shopify-product-reviews ').click(function(e) {
	
  $('.product_page_rht .text_rht .panel_wrap').find('.accord_panel').slideUp();
	// $(this).find('.spr-content').slideToggle();

	 
});
  });

$('.lt_btn').click(function(e) {
    $(this).parent().find('.wrap_mob').slideToggle();
	
});



$('.faq_qu').click(function(e) {
   $(this).parent('.accord_wrap').find('.faq_an').slideToggle();
});




 /* Product Page */
 /* Slider Syncing */
  
/* Fade */
$('.fade').slick({
  dots: true,
  infinite: true,
  speed: 500,
  fade: true,
  arrows: false,
  cssEase: 'linear'

});
$(window).on('load resize', function(){
	
	var winWidth = $(window).width();
if(winWidth < 769)
{
$(".sb-search").insertBefore(".wrap_mob");	
	
	}


	});
	
	

	
 $(".range_slider.two_handle.pr").slider({max: 500, min:150,
        range: true,
        values: [150, 500]
    }).slider("float");
	
	 $(".range_slider.two_handle.vel").slider({max: 349, min:19,
        range: true,
        values: [19, 349]
    }).slider("float");
	
	 

$(".custom-select select").change(function () { 

	   var str = ""; 
	   str = $(this).find(":selected").text(); 
	   $(this).parent().find(".out").text(str); 
	}).trigger('change');
	


$('.nar_ser').click(function(e) {
	$('.fadeBg').toggle();
	$('body').toggleClass('allFade');
   $(this).parent('.main').find('.airsoft_saidbar').slideToggle();
});

  

 $('.slider-home').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
   autoplay:true,
   autoplaySpeed:6000,
  
  asNavFor: '.slider-thumb'
});
$('.slider-thumb').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.slider-home',
  dots: false,
   autoplay: true,
   autoplaySpeed: 6000,
   arrows: false,
 
  focusOnSelect: true,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.post_section.slick-initialized .slick-slide').click(function(e) {
e.preventDefault();


});

